export const LaboratoryStaffTableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Tipo de Personal',
                    type: 'custom-html',
                    key: 'type_staff',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: "Permanente/ Nombramiento",
                    type: 'text',
                    key: 'quantity',

                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}